module.exports = Object.freeze({
  KEYCLOAK_REALM: process.env.REACT_APP_KEYCLOAK_REALM,
  KEYCLOAK_CLIENT: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  AUTH_URL: process.env.REACT_APP_AUTH_BASE_URL,
  SERVER_URL: process.env.REACT_APP_SERVER_BASE_URL,
  WEBSOCKET_URL: process.env.REACT_APP_WEBSOCKET_URL,
});
